import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "redeem" };
const _hoisted_2 = { class: "form-field-inner" };
const _hoisted_3 = ["value", "disabled"];
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 1,
    class: "status-msg"
};
const _hoisted_6 = {
    key: 2,
    class: "status-msg"
};
const _hoisted_7 = { class: "status-text" };
const _hoisted_8 = { class: "anchor-bottom" };
import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGButton from './elements/MGButton.vue';
import { useAuth } from '@/composables/useAuth';
import { useReferrals } from '@/composables/useReferrals';
import { useQuizApi } from '@/composables/useQuizApi';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RedeemMGMPage',
    setup(__props) {
        useAuth();
        const { applyCode } = useReferrals();
        const { getQuestionnaireByKey } = useQuizApi();
        const router = useRouter();
        const suffix = ref('');
        const display = computed(() => 'MG-' + suffix.value);
        const submitting = ref(false);
        const codeAccepted = ref(false);
        const starting = ref(false);
        const errorMsg = ref(null);
        function clear() {
            suffix.value = '';
            errorMsg.value = null;
        }
        function onInput(e) {
            errorMsg.value = null;
            const el = e.target;
            let v = el.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
            while (v.startsWith('MG'))
                v = v.slice(2);
            suffix.value = v.slice(0, 5);
            el.value = display.value;
        }
        const MESSAGES = {
            InvalidCode: { title: "We couldn't find that code.", body: 'Please check it and try again.' },
            AlreadyReferred: { title: "Already redeemed.", body: "You've already used a referral code." },
            CodeUsageLimitReached: { title: "Code limit reached.", body: 'This code has reached its usage limit.' },
            BudgetExceeded: { title: "Offer unavailable.", body: 'This offer is fully subscribed right now.' },
            WrongEmployer: { title: "Code not valid.", body: "This code isn't valid for your employer." },
            CustomerCannotReferThemselves: { title: "That's your own code.", body: "You can't redeem your own referral code." },
            ReferrerRefereeNotFound: { title: "Something went wrong.", body: "We couldn't apply that code. Please try again." },
            MGMDisabled: { title: "Not available.", body: "Referrals aren't available right now." },
        };
        const FALLBACK = { title: 'Something went wrong.', body: 'Please try again.' };
        function redeem() {
            if (!suffix.value || submitting.value)
                return;
            submitting.value = true;
            errorMsg.value = null;
            applyCode(display.value, (result) => {
                submitting.value = false;
                if (result.success) {
                    codeAccepted.value = true;
                }
                else {
                    errorMsg.value = MESSAGES[result.message] ?? FALLBACK;
                }
            }, () => {
                submitting.value = false;
                errorMsg.value = FALLBACK;
            });
        }
        function proceed() {
            starting.value = true;
            getQuestionnaireByKey('GOALS', (q) => {
                router.push({ path: '/Questionnaire/' + q.id, query: { theme: 'dark', allowBack: 'false' } });
            }, () => {
                starting.value = false;
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "",
                    bgcolor: "transparent",
                    border: 0
                }),
                _createElementVNode("div", _hoisted_1, [
                    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "redeem-title" }, "Got a code from a colleague?", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "redeem-subtitle" }, "Enter a colleague's code and you'll both receive a reward in your Saved to Spend pot.", -1)),
                    _createElementVNode("div", {
                        class: _normalizeClass(["form-field", { 'form-field--accepted': codeAccepted.value, 'form-field--error': errorMsg.value }])
                    }, [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "form-label" }, "Invite code", -1)),
                            _createElementVNode("input", {
                                value: display.value,
                                class: "code-input",
                                type: "text",
                                autocapitalize: "characters",
                                autocomplete: "off",
                                disabled: codeAccepted.value,
                                onInput: onInput
                            }, null, 40, _hoisted_3)
                        ]),
                        (suffix.value && !codeAccepted.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                class: "clear-btn",
                                onClick: clear
                            }, [
                                _createElementVNode("img", {
                                    src: require('@/assets/close.png'),
                                    class: "clear-icon",
                                    alt: "Clear"
                                }, null, 8, _hoisted_4)
                            ]))
                            : _createCommentVNode("", true)
                    ], 2),
                    (!codeAccepted.value)
                        ? (_openBlock(), _createBlock(MGButton, {
                            key: 0,
                            text: "Redeem Code",
                            outline: true,
                            fullWidth: true,
                            noCaps: true,
                            disabled: !suffix.value || submitting.value,
                            onClick: redeem
                        }, null, 8, ["disabled"]))
                        : _createCommentVNode("", true),
                    (codeAccepted.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[1] || (_cache[1] = [
                            _createElementVNode("div", { class: "status-icon status-icon--success" }, "✓", -1),
                            _createElementVNode("p", { class: "status-text" }, [
                                _createElementVNode("strong", null, "Code accepted."),
                                _createTextVNode(" Your reward will be added once your account is set up.")
                            ], -1)
                        ])))
                        : _createCommentVNode("", true),
                    (errorMsg.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "status-icon status-icon--error" }, "✕", -1)),
                            _createElementVNode("p", _hoisted_7, [
                                _createElementVNode("strong", null, _toDisplayString(errorMsg.value.title), 1),
                                _createTextVNode(" " + _toDisplayString(errorMsg.value.body), 1)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(MGButton, {
                            text: codeAccepted.value ? 'Continue' : 'Continue without a code',
                            arrow: true,
                            fullWidth: true,
                            noCaps: true,
                            disabled: starting.value,
                            onClick: proceed
                        }, null, 8, ["text", "disabled"])
                    ])
                ])
            ], 64));
        };
    }
});
